import React from "react";
import { Box, Typography, CardMedia, CardContent } from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";

const CardContainer = styled("div")`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 25px;
  padding: 40px 20px;
  background: linear-gradient(135deg, #e0edf5, #f7fbfe);
`;

const StyledCard = styled("div")`
  flex: 0 1 calc(25% - 25px); /* 4 por fila con espacio */
  max-width: 250px;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  overflow: hidden;
  background-color: #ffffff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.03);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 1024px) {
    flex: 0 1 calc(33.33% - 20px);
  }

  @media (max-width: 768px) {
    flex: 0 1 calc(50% - 20px);
  }

  @media (max-width: 480px) {
    flex: 0 1 100%;
  }
`;

const StyledCardMedia = styled(CardMedia)`
  height: 160px;
  object-fit: cover;
`;

const StyledCardContent = styled(CardContent)`
  padding: 16px 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Title = styled(Typography)`
  font-size: 18px;
  font-weight: 600;
  color: #1e3a5f;
`;

const Description = styled(Typography)`
  font-size: 14px;
  color: #4f4f4f;
  margin-top: 6px;
`;

function ContendorCategoryDestinosHome() {
  const navigate = useNavigate();

  const cards = [
    {
      title: "Atractivos Turísticos",
      description: "Visite nuestros diferentes atractivos turísticos",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTjYicekRRO-T7WV-jltcD2_emlaAX2cRvZdA&s",
      route: "/atractivos turisticos",
    },
    {
      title: "Circuitos Turísticos",
      description: "Visite nuestros diferentes circuitos turísticos",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTrDHSnWDp854mvULILHAfVT6opOC3x1RwMJw&s",
      route: "/circuitos turisticos",
    },
    {
      title: "Hoteles Turísticos",
      description: "Alquila un cuarto desde S/ 50.00",
      image: "https://media-cdn.tripadvisor.com/media/photo-s/07/46/fc/2b/hotel-hacienda-plaza.jpg",
      route: "/hoteles turisticos",
    },
    {
      title: "Hostales Turísticos",
      description: "Alquila un cuarto desde S/ 50.00",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0h_gr7vI1ynNVuW5KWZxQofWhOZNuWmStYDVcbDIk0yFJ51YI-ddQFtqxAvn4zG4SK88",
      route: "/hostales turisticos",
    },
    {
      title: "Gastronomía",
      description: "Todo tipo de comidas a partir de S/ 15.00",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSifWnYVcVyo5nPd0EDueN472kGhf2oOiNJxA&s",
      route: "/gastronomia",
    },
    {
      title: "Agencias de Viaje",
      description: "Contrata viajes elaborados desde S/ 350.00",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNMlehvabSIz60M7l1CFPx1UmTKdx-kBTrVA&s",
      route: "/agencias",
    },
    {
      title: "Guías Turísticos",
      description: "Contrata guías expertos desde S/ 50.00",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcZGDk9anWxjR0MKOYUPTl2Pa21PmHu6eUJA&s",
      route: "/guias turisticos",
    },
    {
      title: "Artesanía",
      description: "Todo tipo de tejidos desde S/ 15.00",
      image: "https://www.amarujourneyperu.com/blog/wp-content/uploads/artesanias1.webp",
      route: "/artesanias",
    },
    {
      title: "Centros Comerciales",
      description: "Ropa, comida, entretenimiento y más a buenos precios",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSuNlt0ERpA0af8MNANVToUf8j7IDJUx2YCsA&s",
      route: "/centros comerciales",
    },
    {
      title: "Transporte Público",
      description: "Servicios seguros a partir de S/ 3.00",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1r2b9JbC2k_7LVaUsC4lk0b9uzipNz-Mz-A&s",
      route: "/transporte publico",
    },
  ];

  return (
    <Box sx={{ marginTop: "50px", paddingBottom: "60px" }}>
      <CardContainer>
        {cards.map((card, i) => (
          <StyledCard key={i} onClick={() => navigate(card.route)}>
            <StyledCardMedia image={card.image} alt={card.title} />
            <StyledCardContent>
              <Title>{card.title}</Title>
              <Description>{card.description}</Description>
            </StyledCardContent>
          </StyledCard>
        ))}
      </CardContainer>
    </Box>
  );
}

export default ContendorCategoryDestinosHome;
